import { createTheme } from '@mui/material/styles';
import type { Theme, PaletteMode } from '@mui/material';
import { getDesignTokens } from './designTokens';
import { getTypography } from './typography';
import { getComponentOverrides } from './componentOverrides';

export function getTheme(mode: PaletteMode): Theme {
    const baseTheme = createTheme({
        ...getDesignTokens(mode),
        ...getTypography(),
    });

    return createTheme(baseTheme, getComponentOverrides(baseTheme));
}
